import { render } from "./UiInputBox.vue?vue&type=template&id=72c839c0&scoped=true"
import script from "./UiInputBox.vue?vue&type=script&lang=js"
export * from "./UiInputBox.vue?vue&type=script&lang=js"

import "./UiInputBox.vue?vue&type=style&index=0&id=72c839c0&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c839c0"]])

export default __exports__